"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.materialTheme = exports.createMaterialTheme = void 0;
const styles_1 = require("@mui/material/styles");
const breakpoints_1 = __importDefault(require("./breakpoints"));
const colors_1 = __importDefault(require("./colors"));
const typography_1 = require("./typography/typography");
const typography_2 = require("./typography");
const createMaterialTheme = (palette) => (0, styles_1.createTheme)({
    breakpoints: {
        values: breakpoints_1.default,
    },
    palette,
    typography: {
        fontFamily: [typography_1.FontFamily.Primary].join(","),
        body1: Object.assign({}, typography_2.typography.variants.primary.main),
        body2: Object.assign({}, typography_2.typography.variants.primary.small),
        h5: Object.assign({}, typography_2.typography.variants.primary.large),
    },
});
exports.createMaterialTheme = createMaterialTheme;
exports.materialTheme = (0, exports.createMaterialTheme)(colors_1.default);
//# sourceMappingURL=materialTheme.js.map